import { useMutation } from "@tanstack/react-query";

import {

    createAuthorizationTransaction,

} from "../services/payments";

export function useCreateAuthorizationTransaction() {

    return useMutation({

        mutationFn: createAuthorizationTransaction,

    });

}